module.exports = __webpack_public_path__ + "img/c4f9dac.png";